import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import RoleBasedDashboard from './pages/role-based-dashboard';
import JobSearchApplication from './pages/job-search-application';
import StudentProfileManagement from './pages/student-profile-management';
import JobInternshipPosting from './pages/job-internship-posting';
import EmployerRegistrationProfile from './pages/employer-registration-profile';
import CandidateManagement from './pages/candidate-management';
import InstitutionManagementPortal from './pages/institution-management-portal';
import AnalyticsReportingDashboard from './pages/analytics-reporting-dashboard';
import InterviewSchedulingManagement from './pages/interview-scheduling-management';
import PricingSubscriptionPlans from './pages/pricing-subscription-plans';
import SecureCheckoutPayment from './pages/secure-checkout-payment';
import PaymentConfirmationReceipt from './pages/payment-confirmation-receipt';
import LiveChatCommunicationHub from './pages/live-chat-communication-hub';
import PredictiveAnalyticsCustomReporting from './pages/predictive-analytics-custom-reporting';
import RegistrationManagementApprovalCenter from './pages/registration-management-approval-center';
import LandingPageRoleSelection from './pages/landing-page-role-selection';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<LandingPageRoleSelection />} />
        <Route path="/landing-page-role-selection" element={<LandingPageRoleSelection />} />
        <Route path="/role-based-dashboard" element={<RoleBasedDashboard />} />
        <Route path="/job-search-application" element={<JobSearchApplication />} />
        <Route path="/student-profile-management" element={<StudentProfileManagement />} />
        <Route path="/job-posting" element={<JobInternshipPosting />} />
        <Route path="/employer-registration-profile" element={<EmployerRegistrationProfile />} />
        <Route path="/candidate-management" element={<CandidateManagement />} />
        <Route path="/institution-management-portal" element={<InstitutionManagementPortal />} />
        <Route path="/analytics-reporting-dashboard" element={<AnalyticsReportingDashboard />} />
        <Route path="/interview-scheduling-management" element={<InterviewSchedulingManagement />} />
        <Route path="/pricing-subscription-plans" element={<PricingSubscriptionPlans />} />
        <Route path="/secure-checkout-payment" element={<SecureCheckoutPayment />} />
        <Route path="/payment-confirmation-receipt" element={<PaymentConfirmationReceipt />} />
        <Route path="/live-chat-communication-hub" element={<LiveChatCommunicationHub />} />
        <Route path="/predictive-analytics-custom-reporting" element={<PredictiveAnalyticsCustomReporting />} />
        <Route path="/registration-management-approval-center" element={<RegistrationManagementApprovalCenter />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
